// services/fontteService/config.ts - services/fontteService.ts split (sub-module config)

import { getApiUrl } from '../apiConfig.js';


export const VPS_API_URL = getApiUrl();


export const VPS_API_KEY = import.meta.env.VITE_VPS_API_KEY || '';
